import { Button } from "@sellar-io/components";
import React, { useEffect } from "react";
import { DialogCTA } from "../../../../../components/modal/Dialog";
import { useForm } from "react-hook-form";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { InputText } from "@sellar-io/components";
import { BasicDialog } from "../../../../../components/modal/BasicDialog";
import { useStorefrontTagUpdate } from "../../../../../hooks/api/v2/storefrontTags/useStorefrontTagUpdate";

type StorefrontEditGroupNameFieldValues = {
  name: string;
};

export const StorefrontEditTagNameDialog = ({
  active,
  onDismiss,
  storefrontTagId,
  selectedTagName,
  setSelectedTagName,
}: {
  active: boolean;
  onDismiss: () => void;
  storefrontTagId: number;
  selectedTagName: string;
  setSelectedTagName: (name: string) => void;
}) => {
  const mutation = useStorefrontTagUpdate(storefrontTagId);
  const { reset, ...form } = useForm<StorefrontEditGroupNameFieldValues>({
    shouldUseNativeValidation: true,
  });

  useEffect(() => {
    reset({ name: selectedTagName });
  }, [reset, selectedTagName]);

  return (
    <BasicDialog
      dialogActive={active}
      loading={mutation.isPending}
      title={`Rename Filter Group`}
      onDismiss={onDismiss}
    >
      <form
        onSubmit={form.handleSubmit((data) => {
          mutation.mutate(
            {
              value: data.name,
            },
            {
              onSuccess: (response) => {
                setSelectedTagName(response.value);
                onDismiss();
              },
            },
          );
        })}
      >
        <div className="mt-4">
          <InputLabel>Name</InputLabel>
          <InputContainer>
            <InputText {...form.register("name")} />
          </InputContainer>
        </div>
        <DialogCTA>
          <Button type={"submit"}>Confirm</Button>
        </DialogCTA>
      </form>
    </BasicDialog>
  );
};
